import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+500',
  label: 'Zurdos confían'
}, {
  value: '6+6',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5★',
  label: 'Calificación'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
export function StatsBar() {
  return <section className="border-y border-white/10 bg-brand-dark py-8 px-4" data-id="element-191">
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-192">
        {stats.map((stat, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.08
      }} className="text-center" data-id="element-193">
            <p className="font-display text-2xl md:text-3xl text-white mb-1" data-id="element-194">
              {stat.value}
            </p>
            <p className="font-body text-[11px] md:text-xs text-brand-green uppercase tracking-wider font-bold" data-id="element-195">
              {stat.label}
            </p>
          </motion.div>)}
      </div>
    </section>;
}